import { I18n } from '@calendly/i18n'
import { IconButton } from '@calendly/ui/components/icon-button'
import { CloseMiniIcon } from '@calendly/ui/components/icons'
import { BodyText } from '@calendly/ui/components/typography'
import { colorTextSecondary } from '@calendly/ui/theme'
import { kebabCase } from 'lodash-es'
import { useDispatch, useSelector } from 'react-redux'

import { useGetUserQuery } from 'common'
import { getMemberName } from 'components/event_type_edit'
import {
  assignedUserGroupsCountSelector,
  eventTypeSelector,
  invitationsListSelector,
  listSelector,
  openUnassignPopup,
} from 'features/managed_event_types'

import { HostTitle } from '../../../../components'
import {
  ItemDetails as AssigneeDetails,
  ItemWrapper as AssigneeWrapper,
  ListWrapper,
  RemoveButtonWrapper,
  StyledUserInfoAvatar,
  SubsectionWrapper,
  TextContainer,
} from '../styles'

export const MembershipsTable = () => {
  const dispatch = useDispatch()
  const { owning_user_group: owningUserGroup } = useSelector(eventTypeSelector)
  const userGroupsCount = useSelector(assignedUserGroupsCountSelector)
  const memberships = useSelector(listSelector)
  const invitations = useSelector(invitationsListSelector)
  const isGroupOwned = !!owningUserGroup
  const isAssignedToOwningGroup = isGroupOwned && userGroupsCount > 0
  const { data: currentUser } = useGetUserQuery()

  const onUnassignClick = (membershipId) => () => {
    dispatch(openUnassignPopup({ membershipId, owner: 'OrganizationMembership' }))
  }

  return (
    <SubsectionWrapper>
      {(memberships.length > 0 || invitations.length > 0) && (
      <ListWrapper>
        {memberships.map(({ owner, id }) => (
          <AssigneeWrapper key={id} id={`${kebabCase(owner.name)}-display`}>
            <AssigneeDetails>
              <StyledUserInfoAvatar
                spaceless
                isNonInteractive
                letter={owner.avatar_letter}
                name={owner.name}
                src={owner.avatar_url}
                uuid={owner.user_uuid}
              />
              <TextContainer>
                <HostTitle>{getMemberName(owner, currentUser)}</HostTitle>
                <BodyText size="medium" color="muted">{owner.email}</BodyText>
              </TextContainer>
            </AssigneeDetails>
            <RemoveButtonWrapper>
              <IconButton
                size="small"
                title={I18n.t('publisher.action.remove')}
                onClick={onUnassignClick(id)}
                disabled={isAssignedToOwningGroup}
              >
                <CloseMiniIcon color={colorTextSecondary} />
              </IconButton>
            </RemoveButtonWrapper>
          </AssigneeWrapper>
        ))}
        {invitations.map(({ owner, id }) => (
          <AssigneeWrapper key={id} id={`${kebabCase(owner.email)}-display`}>
            <AssigneeDetails>
              <StyledUserInfoAvatar
                spaceless
                isNonInteractive
                isPendingUser
                letter={owner.avatar_letter}
                name={owner.name}
                src={owner.avatar_url}
                uuid={owner.user_uuid}
              />
              <TextContainer>
                <HostTitle isItalic>
                  {I18n.t('publisher.organization.memberships_picker.pending_invitation')}
                </HostTitle>
                <BodyText size="medium" color="muted">{owner.email}</BodyText>
              </TextContainer>
            </AssigneeDetails>
            <RemoveButtonWrapper>
              <IconButton
                size="small"
                title={I18n.t('publisher.action.remove')}
                onClick={onUnassignClick(id)}
                disabled={isAssignedToOwningGroup}
              >
                <CloseMiniIcon color={colorTextSecondary} />
              </IconButton>
            </RemoveButtonWrapper>
          </AssigneeWrapper>
        ))}
      </ListWrapper>
      )}
    </SubsectionWrapper>
  )
}
